import createApp from 'createApp'
const landingInternalNav = () => import('Components/Landing/landingInternalNav.vue')
const usageBox = () => import('Components/Landing/Usage/usageBox.vue')

createApp({
  components: {
    landingInternalNav,
    usageBox,
  },
})